import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { TrendingUp, Info } from 'lucide-react';
interface HeroBannerProps {
  name: string;
  avatar: string;
  weeklyImpact: number;
  onShowCommunityImpact?: () => void;
}
export function HeroBanner({
  name,
  avatar,
  weeklyImpact,
  onShowCommunityImpact
}: HeroBannerProps) {
  return <div className="relative w-full pt-20 pb-8 px-6 text-white overflow-hidden bg-green-600" data-id="element-57">
      {/* Pattern Overlay */}
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)'
    }} data-id="element-58" />

      {/* Content */}
      <div className="relative z-10 max-w-md mx-auto" data-id="element-59">
        {/* Centered Profile */}
        <div className="flex flex-col items-center mb-8" data-id="element-60">
          <Avatar className="h-32 w-32 border-4 border-white/30 mb-4 shadow-2xl" data-id="element-61">
            <AvatarImage src={avatar} data-id="element-62" />
            <AvatarFallback className="text-2xl" data-id="element-63">
              {name.charAt(0)}
            </AvatarFallback>
          </Avatar>
          <h2 className="text-2xl font-normal mb-1" data-id="element-64">Ciao, {name}! 👋</h2>
          <p className="text-sm text-white/90" data-id="element-65">
            Pronto/a a fare la differenza oggi?
          </p>
        </div>

        {/* Weekly Impact */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20 shadow" data-id="element-66">
          <div className="flex items-center justify-between mb-3" data-id="element-67">
            <div className="flex items-center gap-2" data-id="element-68">
              <TrendingUp className="h-5 w-5 text-white" strokeWidth={2} data-id="element-69" />
              <h3 className="text-base font-normal text-white" data-id="element-70">
                Impatto settimanale
              </h3>
            </div>
            <span className="text-2xl font-normal text-white" data-id="element-71">
              {weeklyImpact}%
            </span>
          </div>
          <div className="w-full bg-white/20 rounded-full h-2 overflow-hidden" data-id="element-72">
            <div className="bg-white h-full rounded-full transition-all duration-500" style={{
            width: `${weeklyImpact}%`
          }} data-id="element-73" />
          </div>
          <div className="flex items-center justify-between mt-3" data-id="element-74">
            <p className="text-xs text-white/90" data-id="element-75">
              {weeklyImpact > 70 ? '🎉 Sopra la media della community!' : weeklyImpact > 40 ? '✨ Continua così!' : '💪 Puoi fare di più!'}
            </p>
            {onShowCommunityImpact && <button onClick={onShowCommunityImpact} className="flex items-center gap-1 text-xs text-white/90 hover:text-white transition-colors" data-id="element-76">
                <Info className="h-4 w-4" strokeWidth={2} data-id="element-77" />
                <span data-id="element-78">Dettagli</span>
              </button>}
          </div>
        </div>
      </div>
    </div>;
}